import mqtt from "mqtt"

const generateRandomString = (length: number): string => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  let randomString = ""

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    randomString += characters.charAt(randomIndex)
  }

  return randomString
}

export default class MqttServer {
  private mqttConfig: {
    mqtt_host: string
    mqtt_ws_port: number
    mqtt_user: string
    mqtt_pwd: string
  }

  private client: mqtt.MqttClient | null
  private clientId: string | null
  private responseRes: Record<string, (payload: string) => void>
  private clearInterval: Record<string, NodeJS.Timeout>
  private timeoutId: NodeJS.Timeout | undefined

  constructor(config: { mqtt_host: string; mqtt_ws_port: number; mqtt_user: string; mqtt_pwd: string }) {
    this.mqttConfig = config
    this.client = null
    this.clientId = null
    this.responseRes = {}
    this.clearInterval = {}
  }

  init(successF?: (success: any) => void, errorF?: (error: any) => void): void {
    const { mqtt_host, mqtt_ws_port, mqtt_user, mqtt_pwd } = this.mqttConfig
    this.clientId = generateRandomString(10) + "_" + new Date().getTime()
    const mqttOption = {
      clientId: this.clientId,
      username: mqtt_user || "htt", // 账号
      password: mqtt_pwd || "password",
    }

    // this.client = mqtt.connect(`ws://${mqtt_host}:${mqtt_ws_port}`, mqttOption);
    // console.log(mqtt_host, mqtt_ws_port);
    if (mqtt_host === "52.63.159.241" && Number(mqtt_ws_port) === 9001) {
      this.client = mqtt.connect(`wss://api.mynoark.au/mqtt/`, mqttOption)
    } else {
      this.client = mqtt.connect(`ws://${mqtt_host}:${mqtt_ws_port}`, mqttOption)
    }

    // 连接
    this.client.on("connect", (e) => {
      // console.info("MQTT 连接成功")
      typeof successF === "function" && successF("success")
    })

    this.client.on("message", (topic, payload) => {
      clearInterval(this.clearInterval[topic])
      clearTimeout(this.timeoutId)

      const res = JSON.parse(payload.toString())
      if (this.responseRes[topic]) {
        this.responseRes[topic](res)
      }
      this.responseRes[res.id] && this.responseRes[res.id](payload.toString())
    })

    this.client.on("error", (error) => {
      typeof errorF === "function" && errorF(error)
    })
  }

  // 关闭
  close(): void {
    this.client && this.client.end()
  }

  // 发布
  pub(topic: string, data: string): void {
    this.client && this.client.publish(topic, data)
  }

  // 订阅
  sub(topic: string, fun?: (payload: string) => void, time = 0): void {
    this.client &&
      this.client.subscribe(topic, (err) => {
        if (!err) {
          if (typeof fun === "function") {
            this.responseRes[topic] = (e) => fun(e)
          }
          if (time) {
            this.clearInterval[topic] = setInterval(() => {
              delete this.responseRes[topic]
              if (typeof fun === "function") {
                fun(JSON.stringify({ code: 408 }))
              }
              clearInterval(this.clearInterval[topic])
              this.unSub(topic)
            }, time)
          }
        } else {
          console.log("subscribe error")
        }
      })
  }

  // 取消订阅
  unSub(topic: string): void {
    this.client && this.client.unsubscribe(topic)
    delete this.responseRes[topic]
  }

  // 获取待返回
  request(topic: string, content: any, fun?: (payload: string) => void, time = 0): void {
    if (!content.id) {
      content.id = generateRandomString(10)
    }

    if (time) {
      this.timeoutId = setTimeout(() => {
        delete this.responseRes[content.id]
        if (typeof fun === "function") {
          this.unSub(topic)
          fun(JSON.stringify({ code: 408 }))
        }
      }, time)
    }

    const req = `${topic}/request`
    const res = `${topic}/response/client/${this.clientId}`
    if (typeof fun === "function") {
      this.responseRes[content.id] = (e) => {
        delete this.responseRes[content.id]
        fun(e)
      }
    }

    content["client"] = this.clientId
    this.sub(res)
    this.pub(req, JSON.stringify(content))
  }

  set(gateway_uuid: string, device_id: number, property_code: string, value: any) {
    let _this = this
    let nowTime = new Date().getTime()
    return new Promise((resolve, reject) => {
      _this.request(
        `/gateway/${gateway_uuid}`,
        {
          id: "set_property_" + nowTime + "_" + device_id,
          action: "set_property",
          data: { device_id, property_code, value },
        },
        (res: any) => {
          res = JSON.parse(res)
          // console.log(res)
          if (res.code && res.id === "set_property_" + nowTime + "_" + device_id) {
            resolve(res.data)
          }
          if (res.code === 408) {
            reject("Server connection timeout")
          }
          reject("Unknown error")
        }
      )
    })
  }
}
